import { Box, Text } from '@chakra-ui/react';

export default function WebAccessibility() {
    return (
        <Box p={6} mr={4}>
            <Text as="h2" dir="rtl" fontSize="5dvh" fontWeight={700} mb={6}>
                הצהרת נגישות - LeadGuitar
            </Text>
            <Text dir="rtl" fontSize="3dvh" mb={4}>
                האינטרנט מהווה כיום את המאגר הגדול ביותר לחופש המידע עבור כלל המשתמשים, ומשתמשים בעלי מוגבלויות בפרט. ככזה, אנו שמים חשיבות רבה במתן אפשרות שווה לאנשים עם מוגבלות לשימוש במידע המוצג באתר, ולאפשר חווית גלישה טובה יותר.
                <br />
                אנו שואפים להבטיח כי השירותים הדיגיטליים יהיו נגישים לאנשים עם מוגבלויות, ועל כן הושקעו משאבים רבים להקל את השימוש באתר עבור אנשים עם מוגבלויות, ככל האפשר, מתוך אמונה כי לכל אדם מגיעה הזכות לחיות בשוויון, כבוד, נוחות ועצמאות.
                <br />
                כדי לממש הבטחה זו, אנו שואפים לדבוק ככל האפשר בהמלצות התקן הישראלי (ת"י 5568) לנגישות תכנים באינטרנט ברמת AA ומסמך WCAG2.1 הבינלאומי.
            </Text>
            <Text dir="rtl" fontSize="3dvh" mb={4}>
                באתר דאגנו:
                <ul>
                    <li>התאמה לניווט מקלדת - מתן אפשרות לניווט ע״י מקלדת</li>
                    <li>הדגשת קישורים באתר</li>
                    <li>הדגשת כותרות באתר</li>
                    <li>הצגת תיאור אלטרנטיבי לתמונות</li>
                    <li>הצהרת נגישות</li>
                    <li>שליחת משוב נגישות</li>
                </ul>
                כללי:
                ב-Lead Guitar אנחנו מאמינים שכל גיטריסט יכול לפרוץ את גבולות הנגינה שלו, בעזרת גישה ממוקדת ואישית שתהפוך את האתגר להישג.
                תוכנית Lead Guitar שואפת לאפשר לכל גיטריסט לממש את הפוטנציאל האישי שלו ולהתמודד עם אתגרי הנגינה המורכבים ביותר בגיטרה.
                באמצעות גישה ממוקדת ומותאמת אישית, אנו מספקים מסלול ממוקד בן 12 שבועות, שמבוסס על הבנה עמוקה של החסמים האישיים ושל הפוטנציאל הייחודי של כל תלמיד.
                אנו מתחייבים ללוות כל נגן במסעו להיכרות עמוקה עם הגיטרה, הטכניקות והכישורים שיאפשרו לו לנגן מתוך ביטחון, עצמאות והשראה - כך שכל נגן יגשים את חלומו המוזיקלי תוך זמן קצר.
            </Text>
            <Text dir="rtl" fontSize="3dvh" mb={4}>
                אם במהלך הגלישה באתר נתקלתם בקושי בנושא נגישות, נשמח לעמוד לרשותכם במגוון ערוצים לפנייה בנושאי נגישות, נשמח לקבל מכם משוב. <br />
                פרטים לפנייה:
                <br />
                שם: להב ציטיאט
                <br />
                טלפון: 050-455-54598
                <br />
                אימייל: lahavleadguitar@gmail.com
                <br />
                כתובת למשלוח דואר: רחוב עמיאל רוז'נסקי 13 רחובות 764579
            </Text>
        </Box>
    );
}
